import React from 'react';
import { SEOSchemas } from './SEOSchemas';
import { BreadcrumbsContainer } from './Breadcrumbs';

/**
 * PageSEO - A convenience wrapper that adds all SEO elements to a page
 * 
 * Usage:
 * <PageSEO 
 *   breadcrumbs={[{ name: 'Resources', url: '/help' }, { name: 'Page Title' }]}
 *   includeReviews={false}
 * />
 */
const PageSEO = ({ 
  breadcrumbs = null,
  includeLocalBusiness = true,
  includeReviews = false,
  includeWebsite = false,
  showBreadcrumbNav = true,
  variant = 'light'
}) => {
  // Convert breadcrumbs to full URLs for schema
  const schemaBrecrumbs = breadcrumbs ? [
    { name: 'Home', url: 'https://buildpilot.com.au' },
    ...breadcrumbs.map(b => ({
      name: b.name,
      url: b.url ? `https://buildpilot.com.au${b.url}` : undefined
    }))
  ].filter(b => b.name) : null;

  return (
    <>
      {/* Visual Breadcrumb Navigation */}
      {showBreadcrumbNav && breadcrumbs && (
        <BreadcrumbsContainer items={breadcrumbs} variant={variant} />
      )}
      
      {/* Schema Markup (rendered at end of page) */}
      <SEOSchemas 
        includeLocalBusiness={includeLocalBusiness}
        includeReviews={includeReviews}
        includeWebsite={includeWebsite}
        breadcrumbs={schemaBrecrumbs}
      />
    </>
  );
};

/**
 * PageSEOFooter - Just the schema markup without visual breadcrumbs
 * Use this when you want schema but already have custom breadcrumbs
 */
export const PageSEOFooter = ({ 
  breadcrumbs = null,
  includeLocalBusiness = true,
  includeReviews = false 
}) => {
  const schemaBrecrumbs = breadcrumbs ? [
    { name: 'Home', url: 'https://buildpilot.com.au' },
    ...breadcrumbs.map(b => ({
      name: b.name,
      url: b.url ? `https://buildpilot.com.au${b.url}` : undefined
    }))
  ].filter(b => b.name) : null;

  return (
    <SEOSchemas 
      includeLocalBusiness={includeLocalBusiness}
      includeReviews={includeReviews}
      breadcrumbs={schemaBrecrumbs}
    />
  );
};

export default PageSEO;
